import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Navigation = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();

  // Helper function to convert menu item to URL-friendly slug
  const createSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  // Helper function to convert submenu items to objects with links
  const createSubmenuItems = (items) => {
    return items.map(item => {
      if (typeof item === 'object') {
        return item; // Already has link
      }
      return {
        label: item,
        link: `/category?category=${createSlug(item)}`
      };
    });
  };

  const menuItems = [
    {
      label: 'Decoration Services',
      submenu: createSubmenuItems([
        'Birthday Decoration',
        'Pre-Wedding Decoration',
        'Anniversary Decoration',
        'Kids Birthday Decoration',
        'Car Boot Decoration'
      ])
    },
    {
      label: 'Company',
      submenu: [
        { label: 'Contact us', link: '/contact' },
        { label: 'Blogs', link: '/blogs' },
        { label: 'About Us', link: '/about' },
        { label: 'FAQ', link: '/faq' }
      ]
    }
  ];

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-6 space-y-2 lg:space-y-0">
      {menuItems.map((item, index) => (
        <div key={index} className="relative group">
          <div className="lg:pb-3">
            <button
              onClick={() => setOpenMenu(openMenu === index ? null : index)}
              className="flex items-center justify-between w-full lg:w-auto text-gray-700 hover:text-[#8B1538] transition-colors text-sm sm:text-base font-medium py-2"
            >
              {item.label}
              <svg
                className={`w-4 h-4 ml-1 transition-transform lg:hidden ${
                  openMenu === index ? 'rotate-180' : ''
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
              <svg
                className="hidden lg:block w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
          {/* Mobile Dropdown */}
          {openMenu === index && (
            <div className="lg:hidden mt-2 pl-4 space-y-1">
              {item.submenu.map((subItem, subIndex) => {
                const isObject = typeof subItem === 'object';
                const label = isObject ? subItem.label : subItem;
                const link = isObject ? subItem.link : '#';
                return (
                  <a
                    key={subIndex}
                    href={link}
                    onClick={(e) => {
                      if (link !== '#') {
                        e.preventDefault();
                        navigate(link);
                      }
                    }}
                    className="block py-2 text-sm text-gray-600 hover:text-[#8B1538] transition-colors"
                  >
                    {label}
                  </a>
                );
              })}
            </div>
          )}
          {/* Desktop Dropdown */}
          <div className="hidden lg:group-hover:block absolute top-full left-0 pt-2 w-56 z-50">
            <div className="bg-white rounded-lg shadow-xl border border-gray-200 py-2">
              {item.submenu.map((subItem, subIndex) => {
                const isObject = typeof subItem === 'object';
                const label = isObject ? subItem.label : subItem;
                const link = isObject ? subItem.link : '#';
                return (
                  <a
                    key={subIndex}
                    href={link}
                    onClick={(e) => {
                      if (link !== '#') {
                        e.preventDefault();
                        navigate(link);
                      }
                    }}
                    className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-[#8B1538] hover:text-white transition-colors cursor-pointer"
                  >
                    {label}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Navigation;

